import React, {useState} from 'react';
import {get} from 'lodash';
import propTypes from 'prop-types';
import styled from '@emotion/styled';
import {Grid, ButtonBase} from '@mui/material';
import {ReactSVG} from 'react-svg';

import Text from '../../../../components/typography';
import Dropdown from '../../../../components/ui/Dropdown';
import {theme} from '../../../../themes/default-theme';
import Cta from '../../../../components/ui/Cta'
import Links from '../../../../components/ui/Links'
import close from '../../../../assets/icons/close.svg';
import enlargeIcon from '../../../../assets/icons/enlarge.svg';
import {Icon, RespImg} from '../../../../components/ui';

const Container = styled.div `
  margin: 30px 0;
  border-bottom: 1px solid ${theme.palette.middleGrey};
`

const FormItem = styled.div`
  display: block;
  margin:${props => props.margin === 'none' ? `0` : `15px 0`};
  text-align: left;

  ${theme.breakpoints.up('md')} {
    margin:${props => props.margin === 'none' ? `0` : `0 0 15px 0`};
  }

  h6 {
    margin-bottom: 15px;
  }
`
const FormCol = styled.div`
  position: relative;
  
  ${theme.breakpoints.down('sm')} {
    ${props => props.position === 'left' && `
      margin-bottom: 30px;
    }`
  }

  ${theme.breakpoints.up('md')} {
    ${props => props.position === 'left' ? `
      padding-right: 15px;
    ` : `
      padding-left: 15px;
    `}
  }
`

const Add = styled.div`
  cursor: pointer;
  ${props => props.margin === 1 && `
    margin-top: 40px;
  `}
  span {
    display: inline-block;
    vertical-align: middle;
  }

  .svg-container {
    svg [fill]{
      fill:white;
    }
  }

  button {
    margin-right: 10px;
    &:hover {
      background-color: ${theme.palette.vividBlue};
    }
  }
`

const Remove = styled.div`
  margin: 30px 0 0;
  padding: 0 0 30px;
  ${props => props.borderBottom !== false && `
    border-bottom: 1px solid ${theme.palette.middleGrey};
  `}
  svg {
    [stroke] {
      stroke: white;
    }
  }
`

const ModelImg = styled.div`
  picture,
  img {
    width: 100%;
    height: auto;
    display: block;
    max-width: 300px;
    margin: 0 auto;
  }
`

const Close = styled.div`
  position: absolute;
  top: -5px;
  right: -5px;

  button {
    padding: 5px;
  }

  svg {
    display: block;
    width: 18px;
    height: 18px;
    [stroke] {
      stroke: ${theme.palette.charcoal};
    }
  }
`

const step1DefaultPropOnChange = () => {};
const step1DefaultPropOnAddModel = () => {};
const step1DefaultPropOnRemoveModel = () => {};

const Step1 = ({formProps, error, onFormChange, state, ranges, modelsOfInterest, onChange = step1DefaultPropOnChange, onAddModel = step1DefaultPropOnAddModel, onRemoveModel = step1DefaultPropOnRemoveModel, showModelDropdown = true}) => {

  const {
    control,
    errors
  } = formProps

  return (
    <>
      {modelsOfInterest.map((item, index) => {

        const itemRanges = ranges.find(range => range.id === item.rangeId);
        const itemSeries = get(itemRanges, 'models', []).find(series => series.seriesTitle === item.seriesTitle);
        // const itemSeries = get(itemRanges, '[0].series', null);
        // const activeSeries = itemSeries ? itemSeries.find(series => series.title === item.series) : null;
        const models = itemSeries && itemSeries.models ? itemSeries.models : [{...itemSeries}] // (dealer stock)

        const dropdownValues = models ? models.map((item, i) => {
          return {
            id: item.id,
            value: item.title,
            text: item.size ? item.size : item.title,
          }
        }).filter(i => {
          // return false if value.id is already in modelsOfInterest
          return ((!modelsOfInterest.find(j => j.id === i.id) || i.id === item.id)) ? true : false
        }) : []

        return (
          <Container key={index + item.id}>
            <Grid container direction={'row'} justifyContent={'space-between'} alignItems={'flex-start'}>
              <Grid
                size={{
                  xs: 12,
                  md: 3
                }}>
                <FormCol position="left">
                  <FormItem>
                    {/* <Dropdown 
                      variant="outlined"
                      showComplete={true}
                      label={'Range*'}
                      options={ranges.map((item, i) => {
                        return {
                          id: item.id,
                          value: item.title,
                          text: item.title,
                        }
                      })}
                      value={item.range}
                      onChange={(e) => onChange(index, 'range', e)}
                      error={error && !item.range} // only post model?
                    /> */}
                    {item.image &&
                      <ModelImg>
                        {item.image.sizes ?
                          <RespImg 
                            {...item.image}
                          />
                          :
                          <img src={item.image} alt={item.title} />
                        }
                      </ModelImg>
                    }
                  </FormItem>
                </FormCol>
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  md: 9
                }}>
                <FormCol position="right">
                  <FormItem>
                    <Close>
                      <ButtonBase onClick={() => onRemoveModel(index)}>
                        <ReactSVG src={close}/>
                      </ButtonBase>
                    </Close>
                    <Text variant="h6" uppercase colour="vividBlue">{item.rangeTitle}</Text>
                    <Dropdown 
                      variant="outlined"
                      showComplete={true}
                      label={null}
                      options={dropdownValues ? dropdownValues : []}
                      disabled={models ? false : true}
                      value={item.title}
                      onChange={(e) => e && onChange(index, models.find(model => model.id === e.id))}
                      // error={error && !item.model}
                    />
                    {/* <Dropdown 
                      variant="outlined"
                      showComplete={true}
                      label={showModelDropdown ? 'Series*' : 'Model*'}
                      options={itemSeries ? itemSeries.map((item, i) => {
                        return {
                          id: item.id,
                          value: item.title,
                          text: item.title,
                        }
                      }) : []}
                      disabled={itemSeries ? false : true}
                      value={item.series}
                      onChange={(e) => onChange(index, 'series', e)}
                      error={error && !item.series}
                    /> */}
                  </FormItem>
                </FormCol>
              </Grid>
              {/* {showModelDropdown &&
                <Grid size={{xs: 12, md: 6}}>
                  <FormCol position="left">
                    <FormItem>
                      <Dropdown 
                        variant="outlined"
                        showComplete={true}
                        label={'Model'}
                        options={models ? models.map((item, i) => {
                          return {
                            id: item.id,
                            value: item.title,
                            text: item.title,
                          }
                        }) : []}
                        disabled={models ? false : true}
                        value={item.model}
                        onChange={(e) => onChange(index, 'model', e)}
                        // error={error && !item.model}
                      />
                    </FormItem>
                  </FormCol>
                </Grid> 
              } */}
            </Grid>
            {/* {modelsOfInterest.length > 1 && */}
            {/* <Grid container direction={'row'} justifyContent={'space-between'} align={'right'}>
              <Grid size={12}>
                <Remove borderBottom={index === 2 ? false : true}>
                  <Links onClick={() => onRemoveModel(index)} svg={close} secondary>
                    Remove
                  </Links>
                </Remove>
              </Grid>
            </Grid> */}
            {/* } */}
          </Container>
        );
      })}
      {modelsOfInterest.length < 3 &&
        <Grid container direction={'row'} justifyContent={'space-between'} align={'left'}>
          <Grid size={12}>
            <Add margin={modelsOfInterest.length === 0 ? 1 : 0} onClick={onAddModel}>
              <Links svg={enlargeIcon}>
                Add Model
              </Links>
            </Add>
          </Grid>
        </Grid>
      }
    </>
  );
}

Step1.propTypes = {
  onChange: propTypes.func,
  onAddModel: propTypes.func,
  onRemoveModel: propTypes.func,
  showModelDropdown: propTypes.bool
}

export default Step1
